export default {
  en: {
    app: {
      menu: { markets: 'Prediction Markets', eco: 'Ecosystem', nodes: 'Buy Nodes', resources: 'Resources' },
      sub: { token_t: 'Cognition Coin ($VER)', token_d: 'Staking & Governance', sec_t: 'Community & Governance', sec_d: 'Decentralized DAO', wp_t: 'Whitepaper V2.0', wp_d: 'Technical Docs', nodes_t: 'Node Purchase', nodes_d: 'Purchase & Stake Nodes' },
      wallet: { connect: 'Connect Wallet' },
      footer: { rights: '© 2026 Verdict Protocol. All Rights Reserved. v1.0.2', terms: 'Terms of Service', privacy: 'Privacy Policy', help: 'Help Center' }
    },
    trading: { loading: 'Select Market', buy: 'Buy', sell: 'Sell', yes: 'Yes', no: 'No', price: 'Price', amount: 'Amount', bal: 'Balance', est_shares: 'Est. Shares', potential_return: 'Potential Return', place_order: 'Place Order', error_amount: 'Please enter a valid amount', error_market: 'Please select a market', order_placed: 'Order placed successfully' },
    home: {
      hero: {
        title: 'Monetize Truth with <span class="gradient-text">AI Governance</span>',
        desc: 'The first decentralized prediction market powered by GPT-4 and Binance Chain. We combine AI oracles with AMM liquidity to build a transparent, tamper-proof truth market, redefining the value of information.',
        btn2: 'Read Whitepaper', judgments: 'AI Judgments',
        buy_nodes: 'Buy Nodes'
      },
      markets: { title: 'Prediction Markets', trade: 'Trade' },
      genesis: { title: 'Genesis Mining Event', desc: 'Participate in early trading to earn VER points. Value flows regardless of outcome.' },
      nodes: {
        title: 'Node Purchase Program',
        subtitle: 'Join the Verdict Network as a Node Operator',
        whitelist: { name: 'Whitelist Node', price: 100, desc: 'Basic node access with early privileges' },
        small: { name: 'Small Node', price: 200, desc: 'Standard node with enhanced capabilities' },
        medium: { name: 'Medium Node', price: 500, desc: 'Advanced node with priority access' },
        large: { name: 'Large Node', price: 1000, desc: 'Premium node (Coming Soon)' },
        super: { name: 'Super Node', price: 2000, desc: 'Elite node (Coming Soon)' },
        buy_now: 'Buy Now',
        connect_wallet: 'Connect Wallet',
        coming_soon: 'Gradually Opening',
        purchase_title: 'Confirm Node Purchase',
        purchase_desc: 'You are about to purchase a {node} for {price} USDT',
        confirm_purchase: 'Confirm purchase of {node} for {price} USDT?',
        cancel: 'Cancel',
        connect_first: 'Please connect your wallet first',
        not_available: 'This node is not available yet',
        processing: 'Processing transaction...',
        purchase_success: '{node} purchased successfully!',
        purchase_failed: 'Purchase failed, please try again',
        info: 'Node operators receive revenue sharing, governance rights, and exclusive access to platform features. Purchases are non-refundable.',
        
        // 新增翻译字段
        stats: {
          nodesActive: 'Nodes Active',
          totalStaked: 'Total Staked',
          avgAPY: 'Avg. APY'
        },
        sectionTitles: {
          chooseTier: 'Choose Your Node Tier',
          chooseSubtitle: 'Select a node tier that matches your investment goals and desired level of participation in the Verdict Network.',
          benefits: 'Node Operator Benefits',
          benefitsSubtitle: 'As a node operator, you gain exclusive access to platform features and revenue sharing.',
          faq: 'Frequently Asked Questions',
          faqSubtitle: 'Common questions about node operation and the purchase process.'
        },
        benefits: {
          revenueSharing: 'Revenue Sharing',
          revenueDesc: 'Earn a percentage of platform fees based on your node tier and participation level.',
          governanceRights: 'Governance Rights',
          governanceDesc: 'Participate in protocol governance decisions, including fee structures and feature prioritization.',
          priorityAccess: 'Priority Access',
          priorityDesc: 'Get early access to new features, markets, and platform enhancements before general release.',
          enhancedSecurity: 'Enhanced Security',
          securityDesc: 'Higher-tier nodes receive additional security features and insurance coverage.'
        },
        faqItems: {
          howPurchase: 'How do I purchase a node?',
          howPurchaseAnswer: 'Connect your wallet, select a node tier, and confirm the transaction. The node will be assigned to your wallet address immediately after confirmation.',
          whatWallet: 'What wallet do I need?',
          whatWalletAnswer: 'You need a Binance Chain compatible wallet like MetaMask, Trust Wallet, or Binance Chain Wallet with BNB for gas fees and USDT for node purchase.',
          canUpgrade: 'Can I upgrade my node later?',
          canUpgradeAnswer: 'Yes, node upgrades are available. You can pay the difference between your current node and the higher tier to upgrade at any time.',
          refundable: 'Are node purchases refundable?',
          refundableAnswer: 'Node purchases are non-refundable. However, you can transfer your node to another wallet address if needed.',
          rewardsDistributed: 'How are rewards distributed?',
          rewardsDistributedAnswer: 'Rewards are distributed weekly based on platform fee revenue. Higher tier nodes receive a larger share of the rewards pool.'
        },
        badges: {
          whitelist: 'Whitelist',
          small: 'Small',
          medium: 'Medium',
          large: 'Large',
          super: 'Super'
        },
        features: {
          whitelist: [
            'Early access to new features',
            'Exclusive community benefits',
            'Early participant rewards',
            'Priority technical support'
          ],
          small: [
            'Basic revenue rights',
            'Community voting rights',
            'Monthly airdrops',
            'Basic technical support'
          ],
          medium: [
            'Medium revenue rights',
            'Advanced voting rights',
            'Quarterly airdrops',
            'Priority technical support',
            'Event invitations'
          ],
          large: [
            'High revenue rights',
            'Governance voting rights',
            'Monthly airdrops',
            'Dedicated technical support',
            'VIP events'
          ],
          super: [
            'Premium revenue rights',
            'Core governance rights',
            'Weekly airdrops',
            '24/7 dedicated support',
            'Founder meetings'
          ]
        }
      },
      faq: {
        title: 'Protocol Architecture & FAQ',
        q1: 'Is my fund safe? How is custody handled?',
        a1: 'Security is our absolute top priority. Verdict operates on a strict non-custodial model. User funds are never touched by the platform but are locked in auditable, multi-signature smart contracts directly on the Binance Chain network, ensuring only you have control.',
        q2: 'Is the Gas Fee expensive on Binance Chain?',
        a2: 'Extremely low. Binance Chain is engineered for high-frequency transactions. Compared to Ethereum, gas fees are negligible (often fractions of a cent). Furthermore, if you stake BNB to obtain gas fee discounts, your transactions can be effectively free.',
        q_trade: 'How does Swing/Band Trading work?',
        a_trade: 'Unlike traditional binary betting, our AMM model allows for continuous trading. Outcome shares fluctuate in real-time based on market sentiment. You can buy "YES" at $0.4 and sell it at $0.7 before the event concludes to lock in profits, enabling sophisticated swing trading strategies.',
        q3: 'Are the contracts Open Source?',
        a3: 'Yes. We firmly believe that "Code is Law". All core settlement, liquidity, and governance contracts are verified on TronScan and fully published on our GitHub repository for community review and verification.',
        q5: 'How does the AI Oracle work?' ,
        a5: 'We deploy a decentralized network of GPT-4 nodes that autonomously scan global authoritative news sources (e.g., Bloomberg, Reuters). It cross-references multiple data points to determine event outcomes with a 99% confidence score, eliminating human bias.'
      },
      marketsDb: [
        { title: "BTC > $100k in 2024?", prob: 65, color: '#00D092', vol: '$450K' },
        { title: "Trump wins US Election?", prob: 48, color: '#3761F9', vol: '$1.2M' },
        { title: "GPT-5 Release Q2?", prob: 30, color: '#9b59b6', vol: '$89K' },
        { title: "ETH Flippening soon?", prob: 12, color: '#ff5e57', vol: '$220K' },
        { title: "Fed cuts rates in March?", prob: 85, color: '#00D092', vol: '$900K' }
      ],
      // 新增通用翻译字段
      common: {
        totalValueLocked: 'Total Value Locked',
        activeMarkets: 'Active Markets',
        volume: 'Volume',
        yes: 'Yes',
        viewAllMarkets: 'View All Markets',
        infrastructure: 'Infrastructure',
        liquidity: 'Liquidity',
        settlement: 'Settlement',
        poweredBy: 'Powered by Binance Chain Architecture',
        strategicPartners: 'Strategic Ecosystem Partners',
        nodesActive: 'Nodes Active',
        totalStaked: 'Total Staked',
        avgAPY: 'Avg. APY'
      }
    },
    legal: {
      updated: 'LAST UPDATED: OCTOBER 24, 2025 | VERSION 3.2',
      terms: {
        title: 'TERMS OF SERVICE',
        intro: 'Please read these Terms of Service ("Terms") carefully. By accessing or using the Verdict Protocol interface, you agree to be bound by these Terms and all terms incorporated by reference.',
        sections: [
          { title: 'Non-Custodial Nature', body: 'The Verdict Protocol is a decentralized, non-custodial protocol. You acknowledge that you maintain full control over your private keys and assets at all times. We do not have access to your funds, nor can we recover them if you lose your credentials.' },
          { title: 'Assumption of Risk', body: 'By utilizing the Services, you represent that you understand the inherent risks associated with cryptographic systems and blockchain-based networks, including the usage and intricacies of native digital assets like TRX and tokens like USDT. You acknowledge that the cost of transacting on the TRON Network is variable and may increase at any time.' },
          { title: 'Prohibited Jurisdictions', body: 'You agree not to access the Interface from any jurisdiction where such access or use is prohibited by applicable law (e.g., United States, North Korea, Iran). You declare that you are not on any trade or economic sanctions lists.' },
          { title: 'No Financial Advice', body: 'All information provided by the Verdict interface is for informational purposes only and should not be construed as professional financial advice. You should conduct your own research (DYOR) before participating in any prediction market.' },
          { title: 'Smart Contract Risks', body: 'While we have conducted extensive testing, smart contracts may contain bugs or vulnerabilities. You accept that we constitute a beta software and you are using it at your own risk. The protocol developers shall not be liable for any losses resulting from contract exploits.' }
        ],
        footer: 'By clicking "Connect Wallet", you acknowledge that you have read and understood these terms.'
      },
      privacy: {
        title: 'PRIVACY POLICY',
        intro: 'Verdict Protocol is committed to protecting your privacy. As a decentralized application running on the public TRON blockchain, our data collection practices are minimal and transparent.',
        sections: [
          { title: 'Public Blockchain Data', body: 'Please be aware that your wallet address, transaction history, and token balances are permanently recorded on the public blockchain. We have no control over this data, and it is accessible to anyone. We do not maintain a private database of user identities.' },
          { title: 'No Personal Information Collected', body: 'We do not collect, store, or process any Personally Identifiable Information (PII) such as your name, email address, phone number, or physical address. Your interaction with the protocol is purely through your Web3 wallet address.' },
          { title: 'Cookies and Local Storage', body: 'We may use local storage or session cookies solely to store your preferences (such as language selection or UI theme). These data are stored locally on your device and are not transmitted to our servers.' },
          { title: 'Third-Party Services', body: 'Our interface may interact with third-party wallets (e.g., TronLink) or RPC providers (e.g., TRON Grid). These entities have their own privacy policies, and we encourage you to review them before using their services.' },
          { title: 'Data Security', body: 'Since we do not hold your personal data or private keys, there is no centralized database to be breached. Your security primarily depends on how you safeguard your own wallet private keys.' }
        ],
        footer: 'We reserve the right to update this policy. Continued use of the interface implies acceptance of any changes.'
      }
    },
    help: {
      title: 'User Guide & Help Center',
      items: [
        { t: 'How to Stake TRX for Energy?', d: 'Save gas fees by freezing TRX.', content: '1. Open TronLink Wallet.\n2. Click "Stake".\n3. Choose "Energy".\n4. Enter amount and confirm. This allows free transactions.' },
        { t: 'How to Connect TronLink?', d: 'Step-by-step wallet setup guide.', content: '1. Install TronLink Extension.\n2. Create a new wallet or import seed phrase.\n3. Click "Connect Wallet" on Verdict top right corner.' },
        { t: 'Understanding Outcome Shares', d: 'How Yes/No pricing works in AMM.', content: 'Prices range from 0 to 1. If YES is 0.60, it means the market believes there is a 60% chance. If you win, you get 1.00 per share.' },
        { t: 'Claiming Winnings', d: 'How to withdraw your profits.', content: 'After a market resolves, go to "My Portfolio", click "Claim" on the winning market. Funds are sent directly to your wallet.' },
        { t: 'Providing Liquidity', d: 'Earn fees by becoming a LP.', content: 'Go to the pool section, deposit USDT/TRX pairs. You will earn 0.3% of every trade made in that market.' }
      ],
      anno: { title: 'Latest Announcements', list: ['Verdict Protocol Beta Launch (2025-10-01)', 'Smart Contract Audit by SlowMist Completed', 'TRON Network Gas Fee Optimization Guide'] }
    },
    whitepaper: { 
      title: 'Verdict Protocol Whitepaper V2.0', 
      vision: { 
        title: '1. Vision & Mission', 
        p1: 'Verdict is dedicated to building the world\'s most efficient decentralized network for information value discovery. We believe that truth should not be monopolized by a few media giants but discovered through the power of the market. By combining blockchain transparency with prediction market game theory, we empower every individual with cognition to turn information into wealth.', 
        p2: 'Our vision is to become the "NASDAQ" of the Web3 era, but instead of trading stocks, we trade the outcomes of future events. Whether it is financial policy, geopolitics, or technological breakthroughs, everything is predictable, and everything is tradable.' 
      }, 
      market: { 
        title: '2. Market Principles & Future Outlook', 
        p1: 'Prediction Markets are based on the "Wisdom of Crowds" theory. Economic research shows that market participants with skin in the game predict the future more accurately than any committee of experts. As global digitization accelerates, the demand for truthful information grows exponentially, outpacing traditional polls and analysts.', 
        p2: 'Verdict leverages the high throughput of the Binance Smart Chain (BSC) to solve the pain points of early prediction markets (like high gas fees on Ethereum). Our AMM mechanism provides infinite liquidity depth, allowing even small users to participate smoothly, marking the transition of prediction markets from an "elite game" to "mass adoption".'
      }, 
      compliance: { 
        title: '3. Protocol Compliance & Decentralization', 
        p1: 'Verdict was designed with the complexity of global regulatory frameworks in mind. As a pure technology protocol, Verdict only provides the deployment of smart contract code and a UI interaction interface; it does not directly operate any gambling business. All trading activities occur via peer-to-peer on-chain interactions.', 
        p2: 'Through DAO (Decentralized Autonomous Organization) governance, ownership of the protocol belongs to the community. This architecture ensures Verdict has strong censorship resistance, similar to Uniswap in the DEX sector. We are committed to building a financial market based on mathematical logic rather than human will, while protecting user privacy.' 
      }, 
      culture: { 
        title: '4. Corporate Culture & Philosophy', 
        p1: 'We believe in "Radical Transparency" and "Absolute Fairness". At Verdict, there are no backdoors, no black boxes. Our team consists of cryptographers, economists, and game theory experts from around the world. We worship technology and believe code can restructure social trust costs. What we are building is not just a trading platform, but a social experiment in cognitive freedom.' 
      } 
    },
    ecosystem: { 
      title: 'Cognition Coin ($VER) Ecosystem', 
      subtitle: 'The Decentralized Value Carrier on Binance Smart Chain',
      origin: { 
        title: '1. Origin: The Philosophy of Winning', 
        p1: 'The name "Cognition Coin" ($VER) is derived from the core philosophy of Changpeng Zhao (CZ) within the Binance Smart Chain ecosystem. In this game theory framework, the world is a vast arena of zero-sum or positive-sum games where the core spirit is "Winning". Victory is not just a result, but the ultimate utilization of Information Asymmetry.',
        p2: 'Verdict Protocol believes that everyone\'s cognition—whether it\'s predicting the US election or the price action of Bitcoin—is an "intangible asset" generated by differences in information processing capabilities. In Web2, this cognition is harvested for free by social media; in Web3, we tokenize it.', 
        quote: 'The essence of gaming is not gambling on luck, but the monetization of cognition. If you see the truth before the market does, that is your deserved reward.', 
        p3: '$VER is not just a medium of exchange; it is the embodiment of the "Winner\'s Mindset". It represents the share of value you capture in this decentralized truth market through wisdom, speed, and decisiveness.' 
      }, 
      utility: { 
        title: '2. Token Utility & Value Capture', 
        l1_t: 'Transaction Fee Rebates', 
        l1_d: 'Holders who stake VER tokens enjoy up to 100% discount on trading fees within the Verdict high-frequency prediction market. This reduces the friction cost for swing traders and creates rigid demand for the token.', 
        l2_t: 'DAO Governance', 
        l2_d: 'Verdict adopts a fully decentralized governance model. VER holders possess proposal and voting rights to decide on new market listings, arbitrate disputed outcomes (as a failsafe to the AI Oracle), and manage the treasury funds.', 
        l3_t: 'Deflationary Black Hole', 
        l3_d: '30% of the protocol revenue is automatically used to buy back VER tokens and send them to a black hole address (0x000...dEaD) for permanent burning. As market volume explodes, the circulating supply of VER will continuously decrease.' 
      }, 
      dist: { 
        title: '3. Distribution & Mining', 
        p1: 'To reward early supporters, Verdict has launched the "Genesis Mining" program. Every interaction on the platform (predicting, providing liquidity) generates points. These points will be converted into VER tokens at the TGE (Token Generation Event) based on a non-linear weighted algorithm.', 
      }, 
      tbl: { 
        cat: 'Category', alloc: 'Allocation', desc: 'Vesting Schedule', 
        r1_c: 'Trade Mining', r1_d: 'Released linearly over 5 years via "Trade-to-Earn".', 
        r2_c: 'DAO Treasury', r2_d: 'Reserved for ecosystem growth, unlocked by vote.', 
        r3_c: 'Team & Advisors', r3_d: '12-month cliff, followed by 24-month linear vesting.', 
        r4_c: 'Initial Liquidity', r4_d: 'Added to SunSwap pool and permanently locked.' 
      } 
    },
    security: { 
      title: 'Security Architecture & Technical Docs', 
      core: { 
        title: '1. Trustless Settlement Layer', 
        p1: 'The core security foundation of the Verdict Protocol lies in its fully trustless settlement architecture. We rely on no centralized servers to handle funds; all value transfers are executed atomically directly on the Binance Smart Chain Virtual Machine.',
        p2: 'The liquidity pool contract, built on the TRC-20 standard, adopts a "Non-Custodial" design. This means that even the project team cannot withdraw user-deposited collateral. The contract\'s admin keys have been burned, ensuring no "backdoor" or "super key" exists to pause the network or freeze assets.' 
      }, 
      immutable: { 
        title: '2. Immutable Deterministic Execution', 
        p1: 'In the blockchain world, Code is Law. Once deployed, Verdict\'s core prediction logic is immutable. As soon as the oracle inputs a result, the contract strictly follows the mathematical formula to distribute winnings.', 
        p2: 'Our smart contract codebase follows Solidity best security practices, preventing Reentrancy attacks, Integer Overflows, and Flash Loan manipulation risks. While third-party audits are scheduled, our open-source code has undergone multiple rounds of "Red Team" stress testing by the TRON developer community.' 
      }, 
      oracle: { 
        title: '3. Decentralized Oracle Mechanism', 
        p1: 'To prevent single points of failure, Verdict introduces a distributed oracle network based on GPT-4.', 
        l1: 'Multi-Source Verification: The system simultaneously scrapes 5+ authoritative sources (Bloomberg, Reuters, AP), triggering resolution only when >80% agree.', 
        l2: 'Weighted Confidence: The AI model weights news sources by reputation, filtering out fake news and social media rumors.', 
        l3: 'Dispute Period: A 24-hour on-chain dispute period follows every resolution, allowing VER holders to challenge the AI via DAO voting.' 
      } 
    }
  },
  zh: {
    app: {
      menu: { markets: '预测市场', eco: '生态系统', nodes: '购买节点', resources: '项目资源' },
      sub: { token_t: '认知代币 ($VER)', token_d: '质押与治理', sec_t: '社区与治理', sec_d: '去中心化 DAO', wp_t: '项目白皮书 V2.0', wp_d: '技术架构文档', nodes_t: '节点购买', nodes_d: '购买与质押节点' },
      wallet: { connect: '连接钱包' },
      footer: { rights: '© 2026 Verdict Protocol. 版权所有. v1.0.2', terms: '服务条款', privacy: '隐私政策', help: '帮助中心' }
    },
    trading: { loading: '请选择市场', buy: '买入', sell: '卖出', yes: '是 (Yes)', no: '否 (No)', price: '均价', amount: '金额', bal: '余额', est_shares: '预估份额', potential_return: '潜在回报', place_order: '确认下单', error_amount: '请输入有效金额', error_market: '请选择市场', order_placed: '订单提交成功' },
    home: {
      hero: {
        title: '用 AI 治理将 <span class="gradient-text">认知变现</span>',
        desc: '全球首个基于 GPT-4 和币安链的去中心化预测市场。融合 AI 预言机与 AMM 动态流动性，打造透明、不可篡改的真理交易平台，让认知变现。',
        btn2: '阅读白皮书', judgments: 'AI 裁决次数',
        buy_nodes: '购买节点'
      },
      markets: { title: '热门预测市场', trade: '交易' },
      genesis: { title: '创世挖矿活动 (Genesis)', desc: '参与早期交易即刻开启挖矿，无论结果输赢，您的每一次交互都将转化为宝贵的 VER 积分。' },
      nodes: {
        title: '节点购买计划',
        subtitle: '加入 Verdict 网络成为节点运营商',
        whitelist: { name: '白名单节点', price: 100, desc: '基础节点权限，享有早期特权' },
        small: { name: '小节点', price: 200, desc: '标准节点，增强功能' },
        medium: { name: '中节点', price: 500, desc: '高级节点，优先访问权' },
        large: { name: '大节点', price: 1000, desc: '高级节点（即将开放）' },
        super: { name: '超级节点', price: 2000, desc: '精英节点（即将开放）' },
        buy_now: '立即购买',
        connect_wallet: '连接钱包',
        coming_soon: '逐步开放中',
        purchase_title: '确认节点购买',
        purchase_desc: '您即将购买 {node}，价格 {price} USDT',
        confirm_purchase: '确认购买 {node}，价格 {price} USDT？',
        cancel: '取消',
        connect_first: '请先连接您的钱包',
        not_available: '此节点暂未开放',
        processing: '处理交易中...',
        purchase_success: '{node} 购买成功！',
        purchase_failed: '购买失败，请重试',
        info: '节点运营商享有收入分成、治理权和平台专属功能访问权限。购买后不可退款。',
        
        // 新增翻译字段
        stats: {
          nodesActive: '活跃节点数',
          totalStaked: '总质押金额',
          avgAPY: '平均年化收益'
        },
        sectionTitles: {
          chooseTier: '选择您的节点层级',
          chooseSubtitle: '选择符合您投资目标和参与度的节点层级，加入 Verdict 网络。',
          benefits: '节点运营商权益',
          benefitsSubtitle: '作为节点运营商，您将获得平台专属功能和收入分成的独家访问权。',
          faq: '常见问题解答',
          faqSubtitle: '关于节点运营和购买流程的常见问题。'
        },
        benefits: {
          revenueSharing: '收入分成',
          revenueDesc: '根据您的节点层级和参与度，获得平台费用的一定比例分成。',
          governanceRights: '治理权',
          governanceDesc: '参与协议治理决策，包括费用结构和功能优先级设置。',
          priorityAccess: '优先访问权',
          priorityDesc: '在正式发布前，优先获得新功能、新市场和平台增强功能的访问权。',
          enhancedSecurity: '增强安全性',
          securityDesc: '高级节点享有额外的安全功能和保险保障。'
        },
        faqItems: {
          howPurchase: '如何购买节点？',
          howPurchaseAnswer: '连接您的钱包，选择节点层级，确认交易。节点将在确认后立即分配到您的钱包地址。',
          whatWallet: '我需要什么钱包？',
          whatWalletAnswer: '您需要一个兼容币安链的钱包，如 MetaMask、Trust Wallet 或币安链钱包，并准备 BNB 用于支付 Gas 费，USDT 用于购买节点。',
          canUpgrade: '以后可以升级节点吗？',
          canUpgradeAnswer: '是的，节点升级功能可用。您可以随时支付当前节点与更高层级之间的差价进行升级。',
          refundable: '节点购买可以退款吗？',
          refundableAnswer: '节点购买不可退款。但是，如果需要，您可以将节点转移到另一个钱包地址。',
          rewardsDistributed: '奖励如何分配？',
          rewardsDistributedAnswer: '奖励根据平台费用收入每周分配。更高级别的节点获得更大比例的奖励池份额。'
        },
        badges: {
          whitelist: '白名单',
          small: '小',
          medium: '中',
          large: '大',
          super: '超级'
        },
        features: {
          whitelist: [
            '新功能早期访问',
            '独家社区权益',
            '早期参与者奖励',
            '优先技术支持'
          ],
          small: [
            '基础收益权',
            '社区投票权',
            '月度空投',
            '基础技术支持'
          ],
          medium: [
            '中等收益权',
            '高级投票权',
            '季度空投',
            '优先技术支持',
            '活动邀请'
          ],
          large: [
            '高收益权',
            '治理投票权',
            '月度空投',
            '专属技术支持',
            'VIP活动'
          ],
          super: [
            '高级收益权',
            '核心治理权',
            '周度空投',
            '24/7专属支持',
            '创始人会议'
          ]
        }
      },
      faq: {
        title: '底层架构与常见问题',
        q1: '资金安全吗？资金由谁托管？',
        a1: '安全是我们的最高优先级。Verdict 采用严格的非托管模式运行。用户的资金从未被平台持有，而是锁定在币安智能链上经过多重审计的智能合约中。这意味着只有您自己掌握资金的控制权，杜绝了任何中心化挪用的风险。',
        q2: '交易 Gas 费（手续费）贵吗？',
        a2: '极低，这正是我们选择币安智能链（BSC）的原因。BSC 专为高频交易设计，相比以太坊高昂的费用，这里的 Gas 费几乎可以忽略不计。更重要的是，如果您通过质押 BNB 获取足够的燃料折扣，您的交易成本可以大幅降低。',
        q_trade: '什么是波段交易 (Swing Trading)？',
        a_trade: '不同于传统的定局对赌，Verdict 采用了先进的 AMM（自动做市商）机制。这意味着预测份额的价格会实时波动。您可以像炒币一样，例如在概率 40% 時買入，涨到 70% 时卖出，无需等待最终结果揭晓即可提前套现获利，实现灵活的波段操作。',
        q3: '合约代码是开源的吗？',
        a3: '是的，我们坚信"代码即法律"。所有的核心结算、流动性池和治理合约均已在 TronScan 上完成验证，并完全在我们的 GitHub 仓库中开源，供社区随时审查和校验。',
        q5: 'AI 预言机是如何工作的？',
        a5: '我们部署了一个去中心化的 GPT-4 节点网络，它会自动扫描全球权威新闻源（如路透社、彭博社等）。系统会对多个独立数据源进行交叉验证，以 99% 的置信度确定事件结果，从而最大限度地消除人为操纵和偏见。'
      },
      marketsDb: [
        { title: "比特币 2024 年突破 10 万美元？", prob: 65, color: '#00D092', vol: '$450K' },
        { title: "特朗普赢得美国大选？", prob: 48, color: '#3761F9', vol: '$1.2M' },
        { title: "OpenAI Q2 发布 GPT-5？", prob: 30, color: '#9b59b6', vol: '$89K' },
        { title: "以太坊市值超越比特币？", prob: 12, color: '#ff5e57', vol: '$220K' },
        { title: "美联储 3 月降息？", prob: 85, color: '#00D092', vol: '$900K' }
      ],
      // 新增通用翻译字段
      common: {
        totalValueLocked: '总锁定价值',
        activeMarkets: '活跃市场',
        volume: '交易量',
        yes: '是',
        viewAllMarkets: '查看所有市场',
        infrastructure: '基础设施',
        liquidity: '流动性',
        settlement: '结算层',
        poweredBy: '基于币安链架构',
        strategicPartners: '战略生态合作伙伴',
        nodesActive: '活跃节点数',
        totalStaked: '总质押量',
        avgAPY: '平均年化收益'
      }
    },
    legal: {
      updated: '最后更新于：2025年10月24日 | 版本 3.2',
      terms: {
        title: '服务条款 (Terms of Service)',
        intro: '请在访问或使用 Verdict 协议界面之前仔细阅读本条款。连接钱包或进行任何交易即表示您完全接受并同意受本条款约束。',
        sections: [
          { title: '非托管性质声明', body: 'Verdict 协议是一个去中心化的非托管协议。您承认您始终完全控制自己的私钥和资产。平台方无法访问您的资金，亦无法在您丢失私钥或助记词时协助找回资产。' },
          { title: '风险承担', body: '使用本服务即表示您了解加密系统和区块链网络的固有风险，包括 BNB 和 USDT 等数字资产的波动性。您知晓币安智能链（BSC）的交易 Gas 费是动态变化的，可能会随网络拥堵而增加。' },
          { title: '禁止的司法管辖区', body: '您承诺不会从任何禁止此类服务的司法管辖区（例如美国、朝鲜、伊朗等受制裁国家）访问本界面。您声明您未被列入任何贸易或经济制裁名单。' },
          { title: '非投资建议', body: 'Verdict 界面提供的所有数据（如胜率、赔率）仅供参考，不构成任何形式的投资建议或财务指导。在参与任何预测市场之前，请务必进行独立研究（DYOR）。' },
          { title: '智能合约风险', body: '尽管我们的代码经过测试，但智能合约可能仍存在未知的漏洞。您同意本产品处于 Beta 测试阶段，并自愿承担因代码漏洞、黑客攻击或网络故障导致的资金损失风险，开发团队对此不承担赔偿责任。' }
        ],
        footer: '点击“连接钱包”即表示您已阅读并理解上述所有条款。'
      },
      privacy: {
        title: '隐私政策 (Privacy Policy)',
        intro: 'Verdict 协议致力于保护您的隐私。作为运行在波场公链上的去中心化应用（DApp），我们的数据收集行为极简且透明。',
        sections: [
          { title: '链上公开数据', body: '请注意，您的钱包地址、交易记录和代币余额将被永久记录在公共区块链上。这些数据是公开透明且不可篡改的，任何人均可查询。我们不维护任何关联用户真实身份的私有数据库。' },
          { title: '不收集个人敏感信息', body: '我们绝不会收集、存储或处理您的任何个人身份信息（PII），例如姓名、电子邮件、电话号码或实际地址。您与协议的交互完全通过您的 Web3 钱包地址进行匿名操作。' },
          { title: 'Cookie 与本地存储', body: '我们可能会使用浏览器本地存储（Local Storage）仅用于保存您的偏好设置（如语言选择、界面主题）。这些数据仅保存在您的设备上，不会传输至我们的服务器。' },
          { title: '第三方服务交互', body: '本界面可能会与第三方钱包（如 TronLink）或 RPC 节点提供商（如 TRON Grid）进行交互。这些实体拥有独立的隐私政策，我们建议您在使用前仔细阅读其条款。' },
          { title: '数据安全', body: '由于我们不持有您的个人数据或私钥，因此不存在中心化数据库被黑客入侵导致数据泄露的风险。您的资产安全主要取决于您如何妥善保管自己的钱包私钥。' }
        ],
        footer: '我们保留随时更新本政策的权利。继续使用本界面即视为接受变更。'
      }
    },
    help: {
      title: '用户指南与帮助中心',
      items: [
        { t: '如何质押 BNB 获取能量？', d: '冻结 BNB 以免除交易手续费。', content: '1. 打开 MetaMask 钱包。\n2. 点击“质押 (Stake)”。\n3. 选择“能量 (Energy)”。\n4. 输入数量并确认。质押约 2000 BNB 即可享受每日免费交易。' },
        { t: '如何连接 MetaMask 钱包？', d: '钱包安装与连接教程。', content: '1. 在 Chrome 商店安装 MetaMask 插件。\n2. 创建新钱包并保存助记词。\n3. 刷新 Verdict 页面，点击右上角“连接钱包”。' },
        { t: '理解预测份额价格', d: 'AMM 机制下的 Yes/No 定价原理。', content: '价格范围为 0 到 1 USDT。如果 YES 价格为 0.60，代表市场认为有 60% 概率发生。如果您买入并获胜，每个份额将兑换为 1.00 USDT。' },
        { t: '如何领取获胜奖励？', d: '市场决断后的提现流程。', content: '市场出结果后，前往“我的预测”页面，在获胜的市场卡片上点击“领取 (Claim)”。资金将通过智能合约直接发送到您的钱包。' },
        { t: '提供流动性 (LP)', d: '成为做市商赚取手续费。', content: '进入流动性页面，存入 USDT。您将按比例获得该市场所有交易额的 0.3% 作为手续费分红。' }
      ],
      anno: { title: '最新公告', list: ['Verdict 协议 Beta 版正式上线 (2025-10-01)', '慢雾科技 (SlowMist) 智能合约审计完成', '币安智能链 Gas 费优化指南'] }
    },
    whitepaper: {
      title: 'Verdict 协议白皮书 V2.0',
      vision: {
        title: '1. 愿景与使命',
        p1: 'Verdict 致力于构建全球最高效的去中心化信息价值发现网络。我们相信，真理不应被少数媒体巨头垄断，而应通过市场的力量被发现。通过将区块链技术的透明性与预测市场的博弈机制相结合，我们让每一个拥有认知的个体都能将信息转化为财富。',
        p2: '我们的愿景是成为 Web3 时代的“纳斯达克”，但交易的不是股票，而是未来事件的结果。无论是金融政策、地缘政治还是科技突破，一切皆可预测，一切皆可交易。'
      },
      market: {
        title: '2. 市场原理与发展前景',
        p1: '预测市场（Prediction Market）基于“群体的智慧”理论。经济学研究表明，拥有真金白银投入的市场参与者，比任何专家委员会都能更准确地预测未来。随着全球数字化进程加速，对于真实信息的需求呈指数级增长，传统民调和分析机构的滞后性已无法满足需求。',
        p2: 'Verdict 利用波场网络的高吞吐量，解决了早期预测市场（如以太坊早期竞品）Gas 费高昂、交易确认慢的痛点。我们的 AMM 机制提供了无限的流动性深度，使得即便是小额用户也能流畅参与，这标志着预测市场从“精英游戏”走向了“大众普惠”。'
      },
      compliance: {
        title: '3. 协议合规性与去中心化架构',
        p1: 'Verdict 在设计之初就充分考虑了全球监管框架的复杂性。作为一个纯粹的技术协议，Verdict 仅提供智能合约代码的部署和 UI 交互界面，并不直接运营任何赌场业务。所有的交易行为均发生在用户点对点的链上交互中。',
        p2: '通过 DAO（去中心化自治组织）治理，协议的所有权属于社区。这种架构确保了 Verdict 具有极强的抗审查能力，类似于 Uniswap 在 DEX 领域的定位。我们致力于在保护用户隐私的前提下，构建一个符合数学逻辑而非人为意志的金融市场。'
      },
      culture: {
        title: '4. 企业文化与发展哲学',
        p1: '我们信仰“极致透明”与“绝对公平”。在 Verdict，没有后台，没有黑箱。我们的团队由来自全球的密码学家、经济学家和博弈论专家组成，我们崇尚技术至上，相信代码可以重构社会信任成本。我们要做的，不仅仅是一个交易平台，更是一场关于认知自由的社会实验。'
      }
    },
    ecosystem: {
      title: '认知币 (VER) 生态系统白皮书',
      subtitle: '基于币安智能链（BSC）的去中心化认知价值存储载体',
      origin: {
        title: '1. 起源：赵长鹏精神与认知变现',
        p1: '“认知币”（Cognition Coin, $VER）的命名源于币安智能链生态核心精神领袖赵长鹏（CZ）的哲学体系。在CZ的博弈论中，世界是一个巨大的零和或正和博弈场，核心精神在于"赢"。胜利不仅仅是结果，更是一种对信息差（Information Asymmetry）的极致利用。',
        p2: 'Verdict 协议认为，每一个人的认知——无论是对美国大选的预判，还是对比特币走势的直觉——都是由于信息处理能力差异产生的"无形资产"。在传统的Web2世界中，这种认知被社交媒体免费通过流量收割；而在Web3的Verdict生态中，我们将"认知"代币化。',
        quote: '博弈的本质不是赌运气，而是认知的变现。只要你比市场更早看清真相，这就是你应得的奖励。—— CZ核心要义',
        p3: 'VER 代币不仅是交易的媒介，更是“赢家心态”的具象化。它代表了在这个去中心化真理市场中，您通过智慧、速度和决断力所捕获的价值份额。'
      },
      utility: {
        title: '2. 代币生态循环与价值捕获',
        l1_t: '交易手续费深度抵扣',
        l1_d: '在 Verdict 协议的高频预测市场中，持有并质押 VER 代币的用户将享受最高 100% 的交易手续费减免。这不仅降低了波段交易（Swing Trading）的磨损成本，更赋予了代币真实的刚性需求。',
        l2_t: 'DAO 治理与议题决断',
        l2_d: 'Verdict 采用完全的去中心化治理。VER 持有者拥有提案权和投票权，可以决定新市场的开设、争议性结果的最终仲裁（作为 AI 预言机的补充层）以及协议金库资金的使用方向。',
        l3_t: '通缩黑洞机制',
        l3_d: '协议收入的 30% 将自动回购 VER 代币并打入黑洞地址（0x000...dEaD）进行永久销毁。随着预测市场成交量的爆发，VER 的流通量将持续减少，实现价值的螺旋上升。'
      },
      dist: {
        title: '3. 积分兑换与代币分配',
        p1: '为了奖励早期支持者，Verdict 启动了“创世挖矿”计划。用户在平台上的每一次交互（预测、提供流动性）都会产生积分。这些积分将在 TGE（代币生成事件）时，按照非线性加权算法兑换为 VER 代币。',
      },
      tbl: { cat: '分配板块', alloc: '比例', desc: '锁仓与释放机制', r1_c: '交易挖矿', r1_d: '通过“交易即挖矿”产出，线性释放 5 年', r2_c: 'DAO 金库', r2_d: '用于生态建设与做市，由社区投票解锁', r3_c: '团队与顾问', r3_d: '锁仓 12 个月，随后 24 个月线性释放', r4_c: '初始流动性', r4_d: '添加至 SunSwap 底池，永久锁定' }
    },
    security: {
      title: '安全架构与智能合约技术文档',
      core: {
        title: '1. 去信任化结算层 (Trustless Settlement)',
        p1: 'Verdict 协议的核心安全基石在于其完全去信任化的结算架构。我们不依赖任何中心化服务器来处理资金，所有价值转移均直接在币安智能链虚拟机上原子化执行。',
        p2: '基于 BEP-20 标准构建的流动性池合约采用了"非托管"设计。这意味着，即便是项目方也无法提取用户存入的保证金。合约拥有最高的管理员权限已被销毁（Burned），没有任何"后门"或"超级私钥"可以暂停网络或冻结资产。'
      },
      immutable: {
        title: '2. 不可篡改的确定性执行',
        p1: '在区块链世界中，代码即法律（Code is Law）。Verdict 的核心预测逻辑一经部署，即具有不可篡改性。只要预言机输入了结果，合约就会严格按照预定的数学公式进行派奖。',
        p2: '我们的智能合约代码库遵循 Solidity 最佳安全实践，防止了重入攻击 (Reentrancy)、整数溢出 (Overflow) 以及闪电贷操纵风险。虽然目前第三方审计正在排期中，但我们的开源代码已接受了币安智能链社区开发者的多轮"红队"压力测试。'
      },
      oracle: {
        title: '3. AI 预言机的抗操纵机制',
        p1: '为了防止单一数据源故障，Verdict 引入了基于 GPT-4 的分布式预言机网络。',
        l1: '多源验证：系统同时抓取 Bloomberg, Reuters, AP 等 5 个以上权威源，只有当 80% 以上信源一致时才触发裁决。',
        l2: '加权置信度：AI 模型会对新闻来源的信誉度进行加权，过滤假新闻和社交媒体谣言。',
        l3: '争议期：结果公布后有 24 小时链上争议期，VER 代币持有者可发起 DAO 投票挑战 AI 的裁决。'
      }
    }
  },
  tw: {
    app: {
      menu: { markets: '預測市場', eco: '生態系統', nodes: '購買節點', resources: '項目資源' },
      sub: { token_t: '認知代幣 ($VER)', token_d: '質押與治理', sec_t: '社區與治理', sec_d: '去中心化 DAO', wp_t: '項目白皮書 V2.0', wp_d: '技術架構文檔', nodes_t: '節點購買', nodes_d: '購買與質押節點' },
      wallet: { connect: '連接錢包' },
      footer: { rights: '© 2026 Verdict Protocol. 版權所有. v1.0.2', terms: '服務條款', privacy: '隱私政策', help: '幫助中心' }
    },
    trading: { loading: '請選擇市場', buy: '買入', sell: '賣出', yes: '是 (Yes)', no: '否 (No)', price: '均價', amount: '金額', bal: '餘額', est_shares: '預估份額', potential_return: '潛在回報', place_order: '確認下單', error_amount: '請輸入有效金額', error_market: '請選擇市場', order_placed: '訂單提交成功' },
    home: {
      hero: {
        title: '用 AI 治理將 <span class="gradient-text">認知變現</span>',
        desc: '全球首個基於 GPT-4 和幣安鏈的去中心化預測市場。融合 AI 預言機與 AMM 動態流動性，打造透明、不可篡改的真理交易平台，讓認知變現。',
        btn2: '閱讀白皮書', judgments: 'AI 裁決次數',
        buy_nodes: '購買節點'
      },
      markets: { title: '熱門預測市場', trade: '交易' },
      genesis: { title: '創世挖礦活動 (Genesis)', desc: '參與早期交易即刻開啟挖礦，無論結果輸贏，您的每一次交互都將轉化為寶貴的 VER 積分。' },
      nodes: {
        title: '節點購買計劃',
        subtitle: '加入 Verdict 網絡成為節點運營商',
        whitelist: { name: '白名單節點', price: 100, desc: '基礎節點權限，享有早期特權' },
        small: { name: '小節點', price: 200, desc: '標準節點，增強功能' },
        medium: { name: '中節點', price: 500, desc: '高級節點，優先訪問權' },
        large: { name: '大節點', price: 1000, desc: '高級節點（即將開放）' },
        super: { name: '超級節點', price: 2000, desc: '精英節點（即將開放）' },
        buy_now: '立即購買',
        connect_wallet: '連接錢包',
        coming_soon: '逐步開放中',
        purchase_title: '確認節點購買',
        purchase_desc: '您即將購買 {node}，價格 {price} USDT',
        confirm_purchase: '確認購買 {node}，價格 {price} USDT？',
        cancel: '取消',
        connect_first: '請先連接您的錢包',
        not_available: '此節點暫未開放',
        processing: '處理交易中...',
        purchase_success: '{node} 購買成功！',
        purchase_failed: '購買失敗，請重試',
        info: '節點運營商享有收入分成、治理權和平台專屬功能訪問權限。購買後不可退款。',
        badges: {
          whitelist: '白名單',
          small: '小',
          medium: '中',
          large: '大',
          super: '超級'
        },
        features: {
          whitelist: [
            '新功能早期訪問',
            '獨家社區權益',
            '早期參與者獎勵',
            '優先技術支持'
          ],
          small: [
            '基礎收益權',
            '社區投票權',
            '月度空投',
            '基礎技術支持'
          ],
          medium: [
            '中等收益權',
            '高級投票權',
            '季度空投',
            '優先技術支持',
            '活動邀請'
          ],
          large: [
            '高收益權',
            '治理投票權',
            '月度空投',
            '專屬技術支持',
            'VIP活動'
          ],
          super: [
            '高級收益權',
            '核心治理權',
            '周度空投',
            '24/7專屬支持',
            '創始人會議'
          ]
        }
      },
      faq: {
        title: '底層架構與常見問題',
        q1: '資金安全嗎？資金由誰託管？',
        a1: '安全是我們的最高優先級。Verdict 採用嚴格的非託管模式運行。用戶的資金從未被平台持有，而是鎖定在波場網絡上經過多重審計的智能合約中。這意味著只有您自己掌握資金的控制權，杜絕了任何中心化挪用的風險。',
        q2: '交易 Gas 費（手續費）貴嗎？',
        a2: '極低，這正是我們選擇波場的原因。TRON 專為高頻交易設計。相比以太坊高昂的費用，這裡的 Gas 費幾乎可以忽略不計。更重要的是，如果您通過質押 TRX 獲取足夠的能量和帶寬，您的交易甚至可以是完全零成本的。',
        q_trade: '什麼是波段交易 (Swing Trading)？',
        a_trade: '不同於傳統的定局對賭，Verdict 採用了先進的 AMM（自動做市商）機制。這意味著預測份額的價格會實時波動。您可以像炒幣一樣，例如在概率 40% 時買入，漲到 70% 時賣出，無需等待最終結果揭曉即可提前套現獲利，實現靈活的波段操作。',
        q3: '合約代碼是開源的嗎？',
        a3: '是的，我們堅信"代碼即法律"。所有的核心結算、流動性池和治理合約均已在 TronScan 上完成驗證，並完全在我們的 GitHub 倉庫中開源，供社區隨時審查和校驗。',
        q5: 'AI 預言機是如何工作的？',
        a5: '我們部署了一個去中心化的 GPT-4 節點網絡，它會自動掃描全球權威新聞源（如路透社、彭博社等）。系統會對多個獨立數據源進行交叉驗證，以 99% 的置信度確定事件結果，從而最大限度地消除人為操縱和偏見。'
      },
      marketsDb: [
        { title: "比特幣 2024 年突破 10 萬美元？", prob: 65, color: '#00D092', vol: '$450K' },
        { title: "特朗普贏得美國大選？", prob: 48, color: '#3761F9', vol: '$1.2M' },
        { title: "OpenAI Q2 發布 GPT-5？", prob: 30, color: '#9b59b6', vol: '$89K' },
        { title: "以太坊市值超越比特幣？", prob: 12, color: '#ff5e57', vol: '$220K' },
        { title: "美聯儲 3 月降息？", prob: 85, color: '#00D092', vol: '$900K' }
      ],
      // 新增通用翻譯字段
      common: {
        totalValueLocked: '總鎖定價值',
        activeMarkets: '活躍市場',
        volume: '交易量',
        yes: '是',
        viewAllMarkets: '查看所有市場',
        infrastructure: '基礎設施',
        liquidity: '流動性',
        settlement: '結算層',
        poweredBy: '基於幣安鏈架構',
        strategicPartners: '戰略生態合作夥伴',
        nodesActive: '活躍節點數',
        totalStaked: '總質押量',
        avgAPY: '平均年化收益'
      }
    },
    legal: {
      updated: '最後更新於：2025年10月24日 | 版本 3.2',
      terms: {
        title: '服務條款 (Terms of Service)',
        intro: '請在訪問或使用 Verdict 協議界面之前仔細閱讀本條款。連接錢包或進行任何交易即表示您完全接受並同意受本條款約束。',
        sections: [
          { title: '非託管性質聲明', body: 'Verdict 協議是一個去中心化的非託管協議。您承認您始終完全控制自己的私鑰和資產。平台方無法訪問您的資金，亦無法在您丟失私鑰或助記詞時協助找回資產。' },
          { title: '風險承擔', body: '使用本服務即表示您了解加密系統和區塊鏈網絡的固有風險，包括 TRX 和 USDT 等數字資產的波動性。您知曉波場網絡（TRON）的交易 Gas 費是動態變化的，可能會隨網絡擁堵而增加。' },
          { title: '禁止的司法管轄區', body: '您承諾不會從任何禁止此類服務的司法管轄區（例如美國、朝鮮、伊朗等受制裁國家）訪問本界面。您聲明您未被列入任何貿易或經濟制裁名單。' },
          { title: '非投資建議', body: 'Verdict 界面提供的所有數據（如勝率、賠率）僅供參考，不構成任何形式的投資建議或財務指導。在參與任何預測市場之前，請務必進行獨立研究（DYOR）。' },
          { title: '智能合約風險', body: '儘管我們的代碼經過測試，但智能合約可能仍存在未知的漏洞。您同意本產品處於 Beta 測試階段，並自願承擔因代碼漏洞、黑客攻擊或網絡故障導致的資金損失風險，開發團隊對此不承擔賠償責任。' }
        ],
        footer: '點擊“連接錢包”即表示您已閱讀並理解上述所有條款。'
      },
      privacy: {
        title: '隱私政策 (Privacy Policy)',
        intro: 'Verdict 協議致力於保護您的隱私。作為運行在波場公鏈上的去中心化應用（DApp），我們的數據收集行為極簡且透明。',
        sections: [
          { title: '鏈上公開數據', body: '請注意，您的錢包地址、交易記錄和代幣餘額將被永久記錄在公共區塊鏈上。這些數據是公開透明且不可篡改的，任何人均可查詢。我們不維護任何關聯用戶真實身份的私有數據庫。' },
          { title: '不收集個人敏感信息', body: '我們絕不會收集、存儲或處理您的任何個人身份信息（PII），例如姓名、電子郵件、電話號碼或實際地址。您與協議的交互完全通過您的 Web3 錢包地址進行匿名操作。' },
          { title: 'Cookie 與本地存儲', body: '我們可能會使用瀏覽器本地存儲（Local Storage）僅用於保存您的偏好設置（如語言選擇、界面主題）。這些數據僅保存在您的設備上，不會傳輸至我們的服務器。' },
          { title: '第三方服務交互', body: '本界面可能會與第三方錢包（如 TronLink）或 RPC 節點提供商（如 TRON Grid）進行交互。這些實體擁有獨立的隱私政策，我們建議您在使用前仔細閱讀其條款。' },
          { title: '數據安全', body: '由於我們不持有您的個人數據或私鑰，因此不存在中心化數據庫被黑客入侵導致數據洩露的風險。您的資產安全主要取決於您如何妥善保管自己的錢包私鑰。' }
        ],
        footer: '我們保留隨時更新本政策的權利。繼續使用本界面即視為接受變更。'
      }
    },
    help: {
      title: '用戶指南與幫助中心',
      items: [
        { t: '如何質押 TRX 獲取能量？', d: '凍結 TRX 以免除交易手續費。', content: '1. 打開 TronLink 錢包。\n2. 點擊“質押 (Stake)”。\n3. 選擇“能量 (Energy)”。\n4. 輸入數量並確認。質押約 2000 TRX 即可享受每日免費交易。' },
        { t: '如何連接 TronLink 錢包？', d: '錢包安裝與連接教程。', content: '1. 在 Chrome 商店安裝 TronLink 插件。\n2. 創建新錢包並保存助記詞。\n3. 刷新 Verdict 頁面，點擊右上角“連接錢包”。' },
        { t: '理解預測份額價格', d: 'AMM 機制下的 Yes/No 定價原理。', content: '價格範圍為 0 到 1 USDT。如果 YES 價格為 0.60，代表市場認為有 60% 概率發生。如果您買入並獲勝，每個份額將兌換為 1.00 USDT。' },
        { t: '如何領取獲勝獎勵？', d: '市場決斷後的提現流程。', content: '市場出結果後，前往“我的預測”頁面，在獲勝的市場卡片上點擊“領取 (Claim)”。資金將通過智能合約直接發送到您的錢包。' },
        { t: '提供流動性 (LP)', d: '成為做市商賺取手續費。', content: '進入流動性頁面，存入 USDT。您將按比例獲得該市場所有交易額的 0.3% 作為手續費分紅。' }
      ],
      anno: { title: '最新公告', list: ['Verdict 協議 Beta 版正式上線 (2025-10-01)', '慢霧科技 (SlowMist) 智能合約審計完成', '波場網絡 Gas 費優化指南'] }
    },
    whitepaper: {
      title: 'Verdict 協議白皮書 V2.0',
      vision: {
        title: '1. 願景與使命',
        p1: 'Verdict 致力於構建全球最高效的去中心化信息價值發現網絡。我們相信，真理不應被少數媒體巨頭壟斷，而應通過市場的力量被發現。通過將區塊鏈技術的透明性與預測市場的博弈機制相結合，我們讓每一個擁有認知的個體都能將信息轉化為財富。',
        p2: '我們的願景是成為 Web3 時代的“納斯達克”，但交易的不是股票，而是未來事件的結果。無論是金融政策、地緣政治還是科技突破，一切皆可預測，一切皆可交易。'
      },
      market: {
        title: '2. 市場原理與發展前景',
        p1: '預測市場（Prediction Market）基於“群體的智慧”理論。經濟學研究表明，擁有真金白銀投入的市場參與者，比任何專家委員會都能更準確地預測未來。隨著全球數字化進程加速，對於真實信息的需求呈指數級增長，傳統民調和分析機構的滯後性已無法滿足需求。',
        p2: 'Verdict 利用波場網絡的高吞吐量，解決了早期預測市場（如以太坊早期競品）Gas 費高昂、交易確認慢的痛點。我們的 AMM 機制提供了無限的流動性深度，使得即便是小額用戶也能流暢參與，這標誌著預測市場從“精英遊戲”走向了“大眾普惠”。'
      },
      compliance: {
        title: '3. 協議合規性與去中心化架構',
        p1: 'Verdict 在設計之初就充分考慮了全球監管框架的複雜性。作為一個純粹的技術協議，Verdict 僅提供智能合約代碼的部署和 UI 交互界面，並不直接運營任何賭場業務。所有的交易行為均發生在用戶點對點的鏈上交互中。',
        p2: '通過 DAO（去中心化自治組織）治理，協議的所有權屬於社區。這種架構確保了 Verdict 具有極強的抗審查能力，類似於 Uniswap 在 DEX 領域的定位。我們致力於在保護用戶隱私的前提下，構建一個符合數學邏輯而非人為意志的金融市場。'
      },
      culture: {
        title: '4. 企業文化與發展哲學',
        p1: '我們信仰“極致透明”與“絕對公平”。在 Verdict，沒有後台，沒有黑箱。我們的團隊由來自全球的密碼學家、經濟學家和博弈論專家組成，我們崇尚技術至上，相信代碼可以重構社會信任成本。我們要做的，不僅僅是一個交易平台，更是一場關於認知自由的社會實驗。'
      }
    },
    ecosystem: {
      title: '認知幣 (VER) 生態系統白皮書',
      subtitle: '基於波場網絡的去中心化認知價值存儲載體',
      origin: {
        title: '1. 起源：孫學精神與認知變現',
        p1: '“認知幣”（Cognition Coin, $VER）的命名源於波場生態核心精神領袖 Justin Sun 的“孫學”哲學體系。在孫學的博弈論中，世界是一個巨大的零和或正和博弈場，核心精神在於“贏”。勝利不僅僅是結果，更是一種對信息差（Information Asymmetry）的極致利用。',
        p2: 'Verdict 協議認為，每一個人的認知——無論是對美國大選的預判，還是對比特幣走勢的直覺——都是由於信息處理能力差異產生的“無形資產”。在傳統的Web2世界中，這種認知被社交媒體免費通過流量收割；而在Web3的Verdict生態中，我們將“認知”代幣化。',
        quote: '博弈的本質不是賭運氣，而是認知的變現。只要你比市場更早看清真相，這就是你應得的獎勵。—— 孫學核心要義',
        p3: 'VER 代幣不僅是交易的媒介，更是“贏家心態”的具象化。它代表了在這個去中心化真理市場中，您通過智慧、速度和決斷力所捕獲的價值份額。'
      },
      utility: {
        title: '2. 代幣生態循環與價值捕獲',
        l1_t: '交易手續費深度抵扣',
        l1_d: '在 Verdict 協議的高頻預測市場中，持有並質押 VER 代幣的用戶將享受最高 100% 的交易手續費減免。這不僅降低了波段交易（Swing Trading）的磨損成本，更賦予了代幣真實的剛性需求。',
        l2_t: 'DAO 治理與議題決斷',
        l2_d: 'Verdict 採用完全的去中心化治理。VER 持有者擁有提案權和投票權，可以決定新市場的開設、爭議性結果的最終仲裁（作為 AI 預言機的補充層）以及協議金庫資金的使用方向。',
        l3_t: '通縮黑洞機制',
        l3_d: '協議收入的 30% 將自動回購 VER 代幣並打入黑洞地址（0x000...dEaD）進行永久銷毀。隨著預測市場成交量的爆發，VER 的流通量將持續減少，實現價值的螺旋上升。'
      },
      dist: {
        title: '3. 積分兌換與代幣分配',
        p1: '為了獎勵早期支持者，Verdict 啟動了“創世挖礦”計劃。用戶在平台上的每一次交互（預測、提供流動性）都會產生積分。這些積分將在 TGE（代幣生成事件）時，按照非線性加權算法兌換為 VER 代幣。',
      },
      tbl: { cat: '分配板塊', alloc: '比例', desc: '鎖倉與釋放機制', r1_c: '交易挖礦', r1_d: '通過“交易即挖礦”產出，線性釋放 5 年', r2_c: 'DAO 金庫', r2_d: '用於生態建設與做市，由社區投票解鎖', r3_c: '團隊與顧問', r3_d: '鎖倉 12 個月，隨後 24 個月線性釋放', r4_c: '初始流動性', r4_d: '添加至 SunSwap 底池，永久鎖定' }
    },
    security: {
      title: '安全架構與智能合約技術文檔',
      core: {
        title: '1. 去信任化結算層 (Trustless Settlement)',
        p1: 'Verdict 協議的核心安全基石在於其完全去信任化的結算架構。我們不依賴任何中心化服務器來處理資金，所有價值轉移均直接在 TRON 虛擬機 (TVM) 上原子化執行。',
        p2: '基於 TRC-20 標準構建的流動性池合約採用了“非託管”設計。這意味著，即便是項目方也無法提取用戶存入的保證金。合約擁有最高的管理員權限已被銷毀（Burned），沒有任何“後門”或“超級私鑰”可以暫停網絡或凍結資產。'
      },
      immutable: {
        title: '2. 不可篡改的確定性執行',
        p1: '在區塊鏈世界中，代碼即法律（Code is Law）。Verdict 的核心預測邏輯一經部署，即具有不可篡改性。只要預言機輸入了結果，合約就會嚴格按照預定的數學公式進行派獎。',
        p2: '我們的智能合約代碼庫遵循 Solidity 最佳安全實踐，防止了重入攻擊 (Reentrancy)、整數溢出 (Overflow) 以及閃電貸操縱風險。雖然目前第三方審計正在排期中，但我們的開源代碼已接受了波場社區開發者的多輪“紅隊”壓力測試。'
      },
      oracle: {
        title: '3. AI 預言機的抗操縱機制',
        p1: '為了防止單一數據源故障，Verdict 引入了基於 GPT-4 的分佈式預言機網絡。',
        l1: '多源驗證：系統同時抓取 Bloomberg, Reuters, AP 等 5 個以上權威源，只有當 80% 以上信源一致時才觸發裁決。',
        l2: '加權置信度：AI 模型會對新聞來源的信譽度進行加權，過濾假新聞和社交媒體謠言。',
        l3: '爭議期：結果公佈後有 24 小時鏈上爭議期，VER 代幣持有者可發起 DAO 投票挑戰 AI 的裁決。'
      }
    }
  }
}